import React from "react";
import PropTypes from "prop-types";
import { QRCodeCanvas } from "qrcode.react";
import FooterPage from "./FooterPage";
import { Box, Button } from "@mui/material";
import "./styles.css";
import {
  QR_VALUE_DEV,
  QR_VALUE_TEST,
  QR_VALUE_PROD,
} from "../utils/constants.ts";

const styles = {
  errorMessage: { color: "red", marginBottom: "10px", fontWeight: 600, margin: "20px" },
  instructionText: { marginBottom: "20px", fontWeight: 400 },
  linkText: { color: "white" },
  waitText: { marginBottom: "10px", marginTop: "20px", fontWeight: 400 },
};

const SerialNumberCheck = ({ onAccept }) => {
  const getQrValue = () => {
    const { host } = window.location;
    switch (true) {
      case host.includes("localhost"):
        return QR_VALUE_DEV;
      case host.includes("dev"):
        return QR_VALUE_DEV;
      case host.includes("tst"):
        return QR_VALUE_TEST;
      case host.includes("prod"):
        return QR_VALUE_PROD;
      default:
        return QR_VALUE_DEV;
    }
  };

  const handleNext = () => {
    onAccept();
  };

  return (
    <Box className="terms-box">
      <div className="containertnc">
        <div style={styles.errorMessage}>
          The customer has not registered this GM Energy product yet. Please
          have the customer register the product to continue with commissioning.
        </div>
        <div style={styles.instructionText}>
          To register a GM Energy product, the customer can scan this QR code,
          or visit{" "}
          <a
            href="https://gmenergy.gm.com/for-home/here-to-help"
            style={styles.linkText}
          >
            Customer Resources
          </a>{" "}
          on the GM Energy website.
        </div>
        <QRCodeCanvas value={getQrValue()} />
        <div style={styles.waitText}>
          Please wait to refresh this page until you receive confirmation the
          customer has completed product registration.
        </div>
        <div>
          <Button
            variant="contained"
            color="primary"
            onClick={handleNext}
            sx={{ margin: 3 }}
          >
            Refresh
          </Button>
        </div>
      </div>
      <FooterPage />
    </Box>
  );
};

SerialNumberCheck.propTypes = {
  onAccept: PropTypes.func.isRequired,
};

export default SerialNumberCheck;
